import { render, staticRenderFns } from "./BusinessNameAddress.vue?vue&type=template&id=d72fa880&scoped=true&"
import script from "./BusinessNameAddress.vue?vue&type=script&lang=js&"
export * from "./BusinessNameAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72fa880",
  null
  
)

export default component.exports